import script from "./WidgetBienvenue.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetBienvenue.vue?vue&type=script&setup=true&lang=js"

import "./WidgetBienvenue.vue?vue&type=style&index=0&id=7480d022&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7480d022"]])

export default __exports__